import axios from '../../utils/axios.js'

export const query = (query) => axios.setAxiosGetPromise('feedback', query)

export const get = (_id) => axios.setAxiosGetPromise('feedback/' + _id)




// WEBPACK FOOTER //
// ./src/services/system/feedback.js